import axios from 'axios'
import store from "../vuex";
import { Message } from "element-ui";
// import getStore from '../util/index.js'
const CancelToken = axios.CancelToken

// axios.defaults.timeout = 50000
axios.defaults.headers.common['APP-ENV'] = ''
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

let cancel
var resolveHandel
let sessionExpiredHandling = false
const SESSION_EXPIRED_FLAG = 'dbSessionExpiredHandled'
// const baseUrl = '//jkw.bjsdcx.com' //http://47.93.8.185:6080
//const baseUrl = '//10.20.251.63:8028'//http://47.93.8.185:6080
const baseUrl = (typeof cfg !== 'undefined' && cfg.apiBaseUrl)
  ? cfg.apiBaseUrl
  : '//'+cfg.host+':'+cfg.port//http://47.93.8.185:6080
// const baseUrl = '//u2otvad.nat.ipyingshe.com'
// const baseUrl = '//uwygiq.natappfree.cc'
// const baseUrl = '//127.0.0.1:8028'//http://47.93.8.185:6080
// const baseUrl = '//localhost:8028/'

let appEnv = {
  sign: '',
  token: ''
}
let sign = localStorage.getItem('sign')
let token = localStorage.getItem('token')
const ssoPrefix = typeof cfg !== 'undefined' && cfg.ssoPrefix ? cfg.ssoPrefix : ''
const ssoApiBaseUrl = typeof cfg !== 'undefined' && cfg.ssoApiBaseUrl ? cfg.ssoApiBaseUrl : ''
const ssoTokenBaseUrl = typeof cfg !== 'undefined' && cfg.ssoTokenBaseUrl ? cfg.ssoTokenBaseUrl : ''
const healthSiteAjaxOrigin = typeof cfg !== 'undefined' && cfg.healthSiteAjaxOrigin ? cfg.healthSiteAjaxOrigin : ''
const memberCenterApiOrigin = 'https://member.healthoo.com/prod-api'
// let headerobj = {
//     sign:localStorage.getItem('sign'),
//     token:localStorage.getItem('token'),
//     userId:localStorage.getItem('userId'),
//     credenceUnique:localStorage.getItem('credenceUnique')
// }
// function setAppEnv() {
//     axios.defaults.headers.common['APP-ENV'] = params(appEnv)
// }
// setAppEnv()

function params(json) {
  var s = []
  function add(key, value) {
    value = Object.prototype.toString.call(value) === '[object Function]' ? '' : (value == null ? '' : value)
    s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value)
  }

  function buildParams(prefix, obj) {
    var name

    if (Object.prototype.toString.call(obj) === '[object Array]') {
      for (var i = 0, j = obj.length; i < j; i++) {
        var v = obj[i]
        buildParams(prefix + '[' + (typeof v === 'object' ? i : '') + ']', v)
      }
    } else if (typeof obj === 'object') {
      for (name in obj) {
        buildParams(prefix + '[' + name + ']', obj[name])
      }
    } else {
      add(prefix, obj)
    }
  }

  if (!json || typeof (json) === 'string') {
    return json || ''
  } else {
    for (var p in json) {
      buildParams(p, json[p])
    }
  }
  return s.join('&').replace(/%20/g, '+')
}

let appFetchOption = {}

function hasHandledSessionExpired() {
  if (typeof window === 'undefined') {
    return false
  }

  try {
    return window.sessionStorage.getItem(SESSION_EXPIRED_FLAG) === '1'
  } catch (e) {
    return false
  }
}

function shouldBlockByExpiredFlag() {
  return !!(!localStorage.getItem('token') && hasHandledSessionExpired())
}

function resolveBridgeOrigin() {
  if (typeof cfg !== 'undefined' && cfg.authLoginOrigin) {
    return cfg.authLoginOrigin.replace(/\/$/, '')
  }
  if (typeof window !== 'undefined' && (
    window.location.hostname === 'healthoo.net' ||
    window.location.hostname === 'www.healthoo.net'
  )) {
    return 'https://member.healthoo.com'
  }
  return 'https://member.healthoo.com'
}

function resolveBridgeEnv() {
  if (typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  )) {
    return 'local'
  }
  if (typeof window !== 'undefined' && (
    window.location.hostname === 'healthoo.net' ||
    window.location.hostname === 'www.healthoo.net'
  )) {
    return 'prod'
  }
  return 'test'
}

function clearIamBridgeToken(tokenKey) {
  if (
    typeof window === 'undefined' ||
    typeof document === 'undefined' ||
    !tokenKey
  ) {
    return
  }

  var bridgeOrigin = resolveBridgeOrigin()
  var bridgeUrl = new URL(bridgeOrigin + '/authLogin/')
  bridgeUrl.searchParams.set('bridgeMode', '1')
  bridgeUrl.searchParams.set('bridgeEnv', resolveBridgeEnv())
  bridgeUrl.searchParams.set('_t', Date.now())

  var iframe = document.createElement('iframe')
  iframe.src = bridgeUrl.toString()
  iframe.setAttribute('aria-hidden', 'true')
  iframe.style.width = '0'
  iframe.style.height = '0'
  iframe.style.border = '0'
  iframe.style.position = 'absolute'
  iframe.style.left = '-9999px'
  iframe.style.top = '-9999px'
  document.body.appendChild(iframe)

  var bridgeWindow = iframe.contentWindow
  if (!bridgeWindow) {
    if (iframe.parentNode) {
      iframe.parentNode.removeChild(iframe)
    }
    return
  }

  var requestId = 'db_expired_clear_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10)
  var settled = false
  var cleanup = function () {
    if (settled) {
      return
    }
    settled = true
    window.clearTimeout(timeoutTimer)
    window.clearInterval(postTimer)
    window.removeEventListener('message', handleMessage)
    if (iframe.parentNode) {
      iframe.parentNode.removeChild(iframe)
    }
  }
  var postRequest = function () {
    try {
      bridgeWindow.postMessage({
        action: 'iam-clear-biz-token',
        requestId: requestId,
        tokenKey: tokenKey,
        source: tokenKey === 'dfbitToken' ? 'health' : 'db',
        forceAll: true,
        bridgeEnv: resolveBridgeEnv()
      }, bridgeOrigin)
    } catch (error) {}
  }
  var handleMessage = function (event) {
    var data = event.data || {}
    if (
      event.origin !== bridgeOrigin ||
      event.source !== bridgeWindow ||
      data.action !== 'iam-biz-token-cleared' ||
      data.requestId !== requestId
    ) {
      return
    }
    cleanup()
  }

  window.addEventListener('message', handleMessage)
  var postTimer = window.setInterval(postRequest, 500)
  var timeoutTimer = window.setTimeout(cleanup, 4000)
  postRequest()
}

function clearIamBridgeTokensOnDbExpired() {
  // 数据库网非手动退出/登录态过期时，也清除 IAM 中相关快捷登录记录。
  clearIamBridgeToken('sysdbToken')
  clearIamBridgeToken('dfbitToken')
}

function handleSessionExpired(message, context) {
  if (sessionExpiredHandling) {
    return
  }

  sessionExpiredHandling = true
  const expiredMessage = message || '用户信息已过期或已被其他用户登录,请重新登录'

  localStorage.removeItem('token')
  localStorage.removeItem('sign')
  localStorage.removeItem('authToken')
  localStorage.removeItem('authGk')
  localStorage.removeItem('dmiToken')
  clearIamBridgeTokensOnDbExpired()

  store.commit('SetuserInfo', null)
  store.commit('ChangeIslogin', false)
  store.commit('ChangeLoginStatus', false)
  store.commit('SetQueryData', {})
  store.commit('SaveDownloadData', {})

  if (typeof window !== 'undefined') {
    try {
      window.sessionStorage.setItem(SESSION_EXPIRED_FLAG, '1')
    } catch (e) {}
    Message.closeAll()
    Message.error(expiredMessage)
  }
}

function isSessionExpiredResponse(res) {
  return !!(res && (res.error == 700 || res.errorCode == 700 || res.code == 700))
}

function shouldHandleSessionExpired(url, res) {
  if (!isSessionExpiredResponse(res)) {
    return false
  }

  const token = localStorage.getItem('token')
  if (!token) {
    return false
  }

  if (typeof url === 'string' && url.indexOf('api/auth/getMessageCount') > -1) {
    return false
  }

  return true
}

var api = {
  params: params,
  baseUrl: baseUrl,
  all: axios.all,
  setFetchOption(opt = {}) {
    appFetchOption = opt
  },
  setConfig(resHandel) {
    resHandel && (resolveHandel = resHandel)
  },
  fetchGet(url, params = {}) {
    return new Promise((resolve, reject) => {
      if (shouldBlockByExpiredFlag()) {
        reject('用户信息已过期或已被其他用户登录,请重新登录')
        return
      }
      axios.get(url, {
        headers: {
          Authorization: localStorage.getItem('token')
        },
        params: {
          ...appFetchOption,
          ...params
        },
        cancelToken: new CancelToken(c => {
          cancel = c
        })
      }).then(res => {
        //console.log(res)
        //resolveHandel && resolveHandel(res.data)
        if (shouldHandleSessionExpired(url, res.data)) {
          handleSessionExpired(res.data.message || res.data.msg)
          reject(res.data.message || res.data.msg || '用户信息已过期或已被其他用户登录,请重新登录')
          return
        }
        if (res.data.error == 0 || res.data.errorCode==0) {
          resolve(res.data.data)
        } else {
          reject(res.data.message)
        }
      }).catch(error => {
        console.log(error)
        if (axios.isCancel(error)) {
          console.warn('Request canceled', url, error.message)
        } else {
          reject('网络连接失败！')
        }
      })
    })
  },
  fetchGetRaw(url, params = {}) {
    return new Promise((resolve, reject) => {
      if (shouldBlockByExpiredFlag()) {
        reject('用户信息已过期或已被其他用户登录,请重新登录')
        return
      }
      axios.get(url, {
        headers: {
          Authorization: localStorage.getItem('token')
        },
        params: {
          ...appFetchOption,
          ...params
        },
        cancelToken: new CancelToken(c => {
          cancel = c
        })
      }).then(res => {
        if (shouldHandleSessionExpired(url, res.data)) {
          handleSessionExpired(res.data.message || res.data.msg)
          reject(res.data.message || res.data.msg || '用户信息已过期或已被其他用户登录,请重新登录')
          return
        }
        resolve(res.data)
      }).catch(error => {
        console.log(error)
        if (axios.isCancel(error)) {
          console.warn('Request canceled', url, error.message)
        } else {
          reject('网络连接失败！')
        }
      })
    })
  },
  fetchSsoGetRaw(url, params = {}) {
    return new Promise((resolve, reject) => {
      let requestUrl = url
      const queryString = params ? this.params(params) : ''
      if (queryString) {
        requestUrl += (requestUrl.indexOf('?') > -1 ? '&' : '?') + queryString
      }
      fetch(requestUrl, {
        method: 'GET'
      }).then(response => {
        return response.json()
      }).then(res => {
        resolve(res)
      }).catch(() => {
        reject('网络连接失败！')
      })
    })
  },
  fetchPostRaw(url, params = {}) {
    return new Promise((resolve, reject) => {
      if (shouldBlockByExpiredFlag()) {
        reject('用户信息已过期或已被其他用户登录,请重新登录')
        return
      }
      axios.post(url, params, {
        headers: {
          Authorization: localStorage.getItem('token')
        },
        cancelToken: new CancelToken(c => {
          cancel = c
        })
      }).then(res => {
        if (shouldHandleSessionExpired(url, res.data)) {
          handleSessionExpired(res.data.message || res.data.msg)
          reject(res.data.message || res.data.msg || '用户信息已过期或已被其他用户登录,请重新登录')
          return
        }
        resolve(res.data)
      }).catch(error => {
        if (axios.isCancel(error)) {
          console.warn('Request canceled', url, error.message)
        } else {
          reject('网络连接失败！')
        }
      })
    })
  },
  fetchPost(url, params = {}) {
    return new Promise((resolve, reject) => {
      if (shouldBlockByExpiredFlag()) {
        reject('用户信息已过期或已被其他用户登录,请重新登录')
        return
      }
      // if (params instanceof FormData) {
      //     for (var p in appFetchOption) {
      //         params.append(p, appFetchOption[p])
      //     }
      // } else {
      // params = {
      //        userId: userId,
      //     // ...appFetchOption,
      //        params
      // }
      // params.Object.assign()
      Object.assign(params)
      // }
      axios.post(url, params, {
        headers: {
          Authorization: localStorage.getItem('token')
        },
        cancelToken: new CancelToken(c => {
          cancel = c
        })
      }).then(res => {
        resolveHandel && resolveHandel(res.data)
        if (shouldHandleSessionExpired(url, res.data)) {
          handleSessionExpired(res.data.message || res.data.msg)
          reject(res.data.message || res.data.msg || '用户信息已过期或已被其他用户登录,请重新登录')
          return
        }
        if (res.data.error == 0) {
          resolve(res.data.data,res);
        } else {
          reject(res.data.message)
        }
      }).catch(error => {
        if (axios.isCancel(error)) {
          console.warn('Request canceled', url, error.message)
        } else {
          reject('网络连接失败！')
        }
      })
    })
  },
  getBaseConfig(params) {
    return this.fetchPost(`${baseUrl}/api/config/base`, params)
  },
  // 登陆
  userLogin(params) {
    return this.fetchPost(`${baseUrl}/api/userLogin`, params).then((res) => {
      // this.setConfig({ token: res.token, })
      return res
    })
  },
  //手机验证登录
  phoneLogin(params) {
    return this.fetchPost(`${baseUrl}/api/phoneLogin`, params).then((res) => {
      // this.setConfig({ token: res.token, })
      return res
    })
  },
  //获取token
  getToken(params) {
    return this.fetchGet(`${baseUrl}/api/auth/getToken`, params).then((res) => {
      //this.setConfig({ token: '' })
      sign = res.sign;
      token = res.token
      return res
    })
  },
  // loginOut(params) {
  //     return this.fetchGet(`${baseUrl}/api/auth/logout`, params).then((res) => {
  //         //this.setConfig({ token: '' })
  //         return res
  //     })
  // },
  cancelAjax() {
    if (cancel) {
      cancel('中断请求！')
    }
  },
  getSsoLoginUrl(params) {
    return this.fetchSsoGetRaw(
      ssoApiBaseUrl || `${baseUrl}${ssoPrefix}/sso/auth/getUrl`,
      params
    )
  },
  getSsoToken(params) {
    return this.fetchSsoGetRaw(
      ssoTokenBaseUrl || `${baseUrl}${ssoPrefix}/sso/auth/getToken`,
      params
    )
  },
  exchangeHealthSiteToken(params) {
    return this.fetchPostRaw(`${healthSiteAjaxOrigin}/api/sso/third/login`, params).then((res) => {
      return res
    })
  },
  verifyMemberCenterPhoneCode(params) {
    return this.fetchGetRaw(`${memberCenterApiOrigin}/health/api/phone/verifyCode`, params).then((res) => {
      return res
    })
  },
  checkMemberCenterPhoneCode(params) {
    return this.fetchGetRaw(`${memberCenterApiOrigin}/health/api/phone/check`, params).then((res) => {
      return res
    })
  },
  verifyMemberCenterEmailCode(params) {
    return this.fetchGetRaw(`${memberCenterApiOrigin}/health/api/email/verifyCode`, params).then((res) => {
      return res
    })
  },
  checkMemberCenterEmailCode(params) {
    return this.fetchGetRaw(`${memberCenterApiOrigin}/health/api/email/check`, params).then((res) => {
      return res
    })
  },
  exchangeDbSiteToken(params) {
    return this.fetchPostRaw(`${baseUrl}/api/sso/thirdLogin`, params).then((res) => {
      return res
    })
  },
  crossKeySave(key, value) {
    return fetch('/prod-api/permit/all/api/token/save', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ key: key, value: value })
    }).then(function(r) { return r.json(); });
  },
  crossKeyGet(key) {
    return fetch('/prod-api/permit/all/api/token/' + encodeURIComponent(key))
      .then(function(r) { return r.json(); });
  },
  crossKeyDelete(key) {
    return fetch('/prod-api/permit/all/api/token/' + encodeURIComponent(key), { method: 'DELETE' })
      .then(function(r) { return r.json(); });
  },
  fetchGetDmi(url, params = {}) {
    return new Promise((resolve, reject) => {
      const dmiToken = localStorage.getItem('dmiToken')
      const exchangeToken = () => {
        const currentToken = localStorage.getItem('token')
        if (!currentToken) {
          reject('未登录')
          return
        }
        axios.post('/prod-api/api/sso/third/login', {
          thirdType: 'sysdb',
          clientType: 'WEB',
          thirdToken: currentToken
        }, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: currentToken
          }
        }).then(exchangeRes => {
          if (exchangeRes.data && exchangeRes.data.code === 200 && exchangeRes.data.token) {
            localStorage.setItem('dmiToken', exchangeRes.data.token)
            axios.get(url, {
              headers: {
                Authorization: exchangeRes.data.token
              },
              params: params,
              cancelToken: new CancelToken(c => {
                cancel = c
              })
            }).then(res => {
              resolve(res.data)
            }).catch(() => {
              reject('网络连接失败')
            })
          } else {
            reject(exchangeRes.data && (exchangeRes.data.message || exchangeRes.data.msg) || 'token兑换失败')
          }
        }).catch(err => {
          reject('token兑换失败')
        })
      }
      if (dmiToken) {
        axios.get(url, {
          headers: {
            Authorization: dmiToken
          },
          params: params,
          cancelToken: new CancelToken(c => {
            cancel = c
          })
        }).then(res => {
          if (res.data && (res.data.error == 401 || res.data.code == 401)) {
            localStorage.removeItem('dmiToken')
            exchangeToken()
          } else {
            resolve(res.data)
          }
        }).catch(error => {
          reject('网络连接失败')
        })
      } else {
        exchangeToken()
      }
    })
  },
  sendResetPasswordSmsCode(params) {
    return new Promise((resolve, reject) => {
      axios.post('/iam/api/v1/user/password_reset/sms-code/send?dryRun=false', params, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject('网络连接失败！')
      })
    })
  },
  resetPasswordBySms(params) {
    return new Promise((resolve, reject) => {
      axios.post('/iam/api/v1/user/password-reset', params, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject('网络连接失败！')
      })
    })
  },
  getDmiUserInfo() {
    return this.fetchGetDmi('/prod-api/getInfo').then((res) => {
      return res
    })
  },
  getAccountConf(params) {
    return this.fetchGetDmi(`/prod-api/api/business/contacts/findAccountConf/${params.contactsId}`).then((res) => {
      return res
    })
  },
  getBindQrcode(params) {
    return this.fetchGetDmi(`/prod-api/api/business/contacts/bind/qrcode`, params).then((res) => {
      return res
    })
  },
  checkQrcodeState(params) {
    return this.fetchGetDmi(`/prod-api/api/business/contacts/bind/qrcode/state`, params).then((res) => {
      return res
    })
  },
  unbindAccount(params) {
    return this.fetchGetDmi(`/prod-api/api/business/contacts/unbind`, params).then((res) => {
      return res
    })  
  },
  bindQcAccount(params) {
    return this.fetchGetDmi(`/prod-api/api/business/contacts/bind/qc`, params).then((res) => {
      return res
    })
  }
};
[
  ['downloadFile', 'api/downloadFile'],
].forEach(item => {
  api[item[0]] = (data) => {
    console.log(baseUrl)
    return `${baseUrl}/${item[1]}?Authorization=` + localStorage.getItem('token') + params(data)
  }

});

[
  ['wechat', 'api/social/wechat'],
  ['qq', 'api/social/qq'],
  ['weibo', 'api/social/weibo'],
].forEach(item => {
  api[item[0]] = (data) => {
    console.log(baseUrl)
    return `${baseUrl}/${item[1]}`
  }

});

// get
[

  // 首页-tab切换
  // ['tabSwitchApi', 'api/index'],
  // 首页-search搜索
  ['search', 'api/index/search'],
  // 详情-search-details
  ['medicines', 'api/medicines'],
  // page
  ['page', 'api/page'],
  ['getAdList', 'api/getAdList'],
  ['tree', 'api/tree'],
  // ['getPageInfo','api/getPageInfo?tableName=select_zgypdq'],
  // 获取右侧数据
  ['getPageInfo', 'api/getPageInfo'],

  ['getCascaderChildren', 'api/getCascaderChildren'],
  // 详情-表格
  ['medicinesList', 'api/medicinesList'],
  //用户名登录
  // ['userLogin','api/userLogin'],
  //获取用户信息
  ['getUserInfo', 'api/auth/getUserInfo'],
  //第三方登录-获取用户信息
  ['getUserInfoByCode', 'api/social/getUserInfoByCode'],
  //获取token
  // ['getToken','api/auth/getToken'],
  //个人中心-系统消息计数
  ['getMessageCount', 'api/auth/getMessageCount'],
  ['getVipLevelList', 'api/auth/getVipLevelList'],
  ['getBkList', 'api/auth/getBkList'],
  //个人中心-系统消息列表
  ['getMessageList', 'api/auth/getMessageList'],
  //个人中心-子账号列表
  ['getAccountList', 'api/auth/account/list'],
  //发票列表
  ['getReceiptList', 'api/auth/getReceiptList'],
  //个人中心-积分管理
  ['getIntegralList', 'api/auth/getIntegralList'],
  //个人中心-订单管理
  ['getOrderList', 'api/auth/getOrderList'],
  //个人中心-合同管理
  ['getAgreementList', 'api/auth/getAgreementList'],
  //获取详细消息
  ['getMessageDetail', 'api/auth/getMessageDetail'],
  //获取发票内容类型
  ['getReceiptContentList', 'api/getReceiptContentList'],
  ['getIntegralRadio', 'api/getIntegralRatio'],
  //下载资料
  ['fileDownload', 'api/fileDownload'],
  ['checkRegister', 'api/checkRegister'],
  //查询文档
  ['tabsearch', 'api/index'],
  //计算订单价格
  ['discountIntegral', 'api/auth/discountIntegral'],
  ['logoOut', 'api/auth/logOut'],
  //支付宝支付
  // ['alipay','api/aliPay'],
  ['weChatPay', 'api/weChatPay'],
  ['getOrderStatus', 'api/auth/getOrderStatus'],
  //获取订单信息
  ['getOrder', 'api/auth/getOrder'],
  ['computeReceiptAmount', 'api/auth/computeReceiptAmount'],
  // 首页搜索建议
  ['associationList', 'api/associationList'],
  ['getTreeFirst', 'api/getTreeFirst'],
  //服务介绍以及走马灯
  ['getWalkingList', 'api/walking/getWalkingList'],
  //获取左侧树高亮
  ['tableNameByName', 'api/tableNameByName'],
  ['checkPassword', 'api/auth/check/password'],
  ['getSdkDoc', 'api/sdk/getSdkDoc'],
].forEach(item => {
  api[item[0]] = (params) => {
    return api.fetchGet(`${baseUrl}/${item[1]}`, params)
  }
});
// post
[
  // 注册
  ['register', 'api/register'],
  // 忘记密码
  ['forgetPassword', 'api/forgetPassword'],
  //发送验证码
  ['sendCode', 'api/sendCode'],
  ['bindUserInfo', 'api/auth/bindUserInfo'],
  //修改手机号
  ['resetPhone', 'api/auth/resetPhone'],
  //修改密码
  ['updateUserInfo', 'api/auth/updateUserInfo'],
  //个人中心-服务项目
  //个人中心-添加发票抬头
  ['addReceiptHead', 'api/auth/addReceipt'],
  //单条数据添加已读
  ['readMessage', 'api/auth/readMessage'],
  ['deleteMessage', 'api/auth/deleteMessage'],
  ['deleteAccount', 'api/auth/account/deleteAccount'],
  ['addAccount', 'api/auth/account/add'],
  ['updateAccount', 'api/auth/account/update'],
  //全部已读
  ['readAllMessage', 'api/auth/readAllMessage'],
  ['resetPassword', 'api/auth/resetPassword'],
  //修改个人信息
  //上传头像
  ['updateUserHead', 'api/auth/updateUserHead'],
  //创建订单
  ['createOrder', 'api/auth/createOrder'],
  ['uptateOrderStatus', 'api/auth/uptateOrderStatus'],
  ['pay', 'api/auth/pay'],
  // 右侧搜索按钮
  ['pageSearch', 'api/pageSearch'],
  // 右侧统计
  ['pageSearchSum', 'api/pageSearchSum'],
  ['pageSearchEchart', 'api/pageSearchEchart'],

].forEach(item => {
  api[item[0]] = (params) => {
    return api.fetchPost(`${baseUrl}/${item[1]}`, params)
  }
})

export default api



// WEBPACK FOOTER //
// ./src/api/index.js